export const SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]; 